/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import type { InvolvementQuestionResult } from "./involvement-question-result"

export interface CategoryResult {
  category: CategoryResultCategoryEnum
  /**
   * Use score instead
   * @deprecated
   */
  mean: number
  score: number
  valid: boolean
  questionResults: Array<InvolvementQuestionResult>
}

export const CategoryResultCategoryEnum = {
  EMPLOYMENT: "EMPLOYMENT",
  TERRITORY: "TERRITORY",
  SOCIAL: "SOCIAL",
  ENVIRONMENT: "ENVIRONMENT",
  GOVERNANCE: "GOVERNANCE",
  OTHER: "OTHER"
} as const

export type CategoryResultCategoryEnum =
  (typeof CategoryResultCategoryEnum)[keyof typeof CategoryResultCategoryEnum]
